import { render, staticRenderFns } from "./SendRepairTable.vue?vue&type=template&id=e40c2650&scoped=true"
import script from "./SendRepairTable.vue?vue&type=script&lang=js"
export * from "./SendRepairTable.vue?vue&type=script&lang=js"
import style0 from "./SendRepairTable.vue?vue&type=style&index=0&id=e40c2650&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40c2650",
  null
  
)

export default component.exports